import React, { useContext } from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { Link } from "Components/Base/Navigation/Link";
import config from "lib/config";
import LangContext from "./langContext";
import * as CONSTANTS from "./constants";
import {
  ComputerIcon as ONLINE,
  ContactsIcon as CLASSROOM,
  DirectionsRunIcon as ACTIVITY,
} from "Components/Icons";
import styled from "styled-components";
import { GET } from "lib/api";

export const formatCourseDuration = (course) => {
  const languageContext = useContext(LangContext);

  let time = "";

  if (course.durationHours || course.durationMinutes) {
    if (course.durationHours && course.durationHours != 0) {
      time = course.durationHours + " h ";
    }

    if (course.durationMinutes) {
      time += course.durationMinutes + " " + languageContext("minutesshort");
    }
  }

  return time;
};

export const getCourseOnlineLinkLabel = (course, reRegisterLink) => {
  if (!course.lastLoggedIn) {
    return "start";
  }

  if (course.completed) {
    return "show";
  }

  return "continue";
};

export const reRegistrationPossible = (course) => {
  if (course.completed && course.allowUserReRegistration) {
    return true;
  }

  return false;
};

export const getProgressBgColor = (course) => {
  let progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_NEUTRAL;

  if (!course || course === "") {
    return progressColor;
  }

  const PROGRESS_LOW = course.completed === false;
  const PROGRESS_MEDIUM =
    course.completed === false && course.progress && course.progress > 30;
  const PROGRESS_HIGH = course.completed === true;

  if (PROGRESS_LOW) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_NEUTRAL;
  }
  if (PROGRESS_MEDIUM) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_MEDIUM;
  }
  if (PROGRESS_HIGH) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_HIGH;
  }
  return progressColor;
};

export const getProgressColor = (course) => {
  let progressColor = CONSTANTS.COLOR_1;

  if (!course || course === "") {
    return progressColor;
  }

  const PROGRESS_LOW = course.completed === false;
  const PROGRESS_MEDIUM =
    course.completed === false && course.progress && course.progress > 30;
  const PROGRESS_HIGH = course.completed === true;

  if (PROGRESS_LOW) {
    progressColor = CONSTANTS.COLOR_1;
  }
  if (PROGRESS_MEDIUM) {
    progressColor = CONSTANTS.COLOR_1;
  }
  if (PROGRESS_HIGH) {
    progressColor = CONSTANTS.COLOR_4;
  }
  return progressColor;
};

export const getFullName = (person) => {
  let { firstName = "", lastName = "" } = person;

  if (firstName === null) {
    firstName = "";
  }
  if (lastName === null) {
    lastName = "";
  }

  return `${firstName} ${lastName}`.trim();
};

export const getIconBackgroundColor = (type) => {
  if (type == CONSTANTS.COURSE_TYPE_ONLINE) {
    return CONSTANTS.COLOR_COURSE_ONLINE;
  }
  if (type == CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return CONSTANTS.COLOR_COURSE_CLASSROOM;
  }
  if (
    type == CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return CONSTANTS.COLOR_COURSE_ACTIVITY;
  }
};

export const getCardBackgroundColor = (type) => {
  if (type == CONSTANTS.COURSE_TYPE_ONLINE) {
    return CONSTANTS.COLOR_COURSE_ONLINE_BACKGROUND;
  }
  if (type == CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return CONSTANTS.COLOR_COURSE_CLASSROOM_BACKGROUND;
  }
  if (
    type == CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return CONSTANTS.COLOR_COURSE_ACTIVITY_BACKGROUND;
  }
};

export const getProgramTypeIcon = (type) => {
  if (type == CONSTANTS.COURSE_TYPE_ONLINE) {
    return <ONLINE size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
  if (type == CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return <CLASSROOM size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
  if (
    type == CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return <ACTIVITY size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
};

export const getProgramTypeIconClass = (type, useProgram = false) => {
  if (type == CONSTANTS.COURSE_TYPE_ONLINE || type === 1) {
    return useProgram ? "course-icon-online" : "online";
  }
  if (type == CONSTANTS.COURSE_TYPE_CLASSROOM || type === 2) {
    return useProgram ? "course-icon-classroom" : "classroom";
  }
  if (type == CONSTANTS.COURSE_TYPE_PROGRAM) {
    return "program-icon";
  }
  if (type == CONSTANTS.COURSE_TYPE_SURVEY_TO_COMPLETE) {
    return useProgram ? "course-icon-survey" : "survey";
  }
  if (
    type == CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return useProgram ? "course-icon-activity" : "activity";
  }
};

export const filterProgramContent = (steps, selection) => {
  if (selection === CONSTANTS.PROGRESS_ALL) {
    return steps;
  }

  return steps.filter((step) => {
    const ONLINE_STEP = step.type === CONSTANTS.COURSE_TYPE_ONLINE;
    let progress = CONSTANTS.PROGRESS_TODO;

    if (step.completed) {
      progress = CONSTANTS.PROGRESS_DONE;
    }
    if (!step.completed) {
      const filterOnlineStepAsOngoing =
        ONLINE_STEP &&
        step.progress &&
        step.progress > 0 &&
        selection === CONSTANTS.PROGRESS_ONGOING;
      if (filterOnlineStepAsOngoing) {
        progress = CONSTANTS.PROGRESS_ONGOING;
      }
    }

    return progress === selection;
  });
};

export const getProgramProgress = (program) => {
  const { steps } = program;

  let numberOfProgramSteps = 0;
  let completedSteps = 0;
  steps.forEach((step) => {
    if (step.completed && step.mandatory) {
      completedSteps++;
    }
    if (step.mandatory) {
      numberOfProgramSteps++;
    }
  });

  return Math.round((completedSteps / numberOfProgramSteps) * 100) || 0;
};

export const GetRequestedCourseLink = (props) => {
  const { courseId, label, activityId, isPortalOverview } = props;

  let fromString = isPortalOverview ? "ov" : "pr";

  return (
    <Typography>
      <Link
        style={{ display: "flex", alignItems: "center" }}
        color="inherit"
        href={`${config.urlRoot}activities/ActivityDetails.aspx?m=${fromString}&prid=${activityId}&inapp=1&id=${courseId}`}
      >
        {label}
      </Link>
    </Typography>
  );
};

export const GetRequestedCourseCatlogueLink = (props) => {
  const { courseId, label, activityId } = props;

  return (
    <div className="flex flex-end">
      <a
        href={`${config.urlRoot}activities/ActivityApplication.aspx?id=${activityId}&pid=${config.personalId}&coid=${courseId}&prid=`}
      >
        {label}
      </a>
    </div>
  );
};

export const GetRequestedOnlineCourseCatlogueLink = (props) => {
  const { courseId, label, isPortalOverview } = props;

  let fromString = isPortalOverview ? "ov" : "pr";

  return (
    <div className="flex flex-center">
      <a
        href={`${config.urlRoot}activities/onlinecoursedetails.aspx?m=${fromString}&inapp=1&courseid=${courseId}`}
      >
        {label}
      </a>
    </div>
  );
};

export const CardFallbackImage = (props) => {
  const { title } = props;

  return (
    <div className="card-noimage">
      {title && title.length > 1 ? title.substr(0, 2) : title.substr(0, 1)}
    </div>
  );
};

export const navigateToMsTeams = async (activityId) => {
  let url = await GET("v1/msteams/url/:activityId/", {
    activityId,
  });

  if (url) {
    let win = window.open(url, "_blank");
    win.focus();
  }
};

export const CardNoImage = () => {
  return <div />;
};

export const StyledEmptyTag = styled.div`
  height: 30px;
`;

export const StyledEmptyStars = styled.div`
  height: 20px;
`;

export const StyledEmptyActivityTitle = styled.div`
  height: 15px;
`;

export const StyledEmptyDescription = styled.div`
  height: 64px;
  max-height: 64px;
`;

export const StyledEmptyDate = styled.div`
  height: 20px;
`;

export const StyledEmptyProgress = styled.div`
  height: 15px;
  margin: 5px 0;
`;

export const StyledCardBanner = styled.div`
  position: absolute;
  display: flex;
  top: 0px;
  right: 0px;
  padding: 8px;
  font-size: 12px;
`;

export const StyledCardIconContainer = styled.div`
  .card-course-icon {
    position: absolute;
    top: 5px;
    left: 5px;
  }
`;

export const StyledCardLockIconContainer = styled.div`
  left: 0px !important;
  top: 0px !important;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 50, 50, 0.3);
  border-radius: 5px;
  z-index: 2;
`;

export const StyledCardLockInformationTextBox = styled.div`
  font-size: 16px;
  border-radius: 4px;
  padding: 0 4px;
`;

export const StyledFooterButtonMobileViewport = {
  height: "20px",
  lineHeight: "20px",
  marginBottom: "5px",
};

export const StyledFooterIcon = styled.div`
  min-width: 80px;
  position: absolute;
  top: -20px;
`;
